"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.SEARCH_TYPES = exports.SEARCH_DATA_PATH = exports.LOOKUP_REQUEST_KEY = exports.LOOKUP_NOT_FOUND_PATH = exports.LOOKUP_FOUND_PATH = exports.LOOKUP_DATA_PATH = exports.DSS_UNREGISTERED = exports.DSS_SERVICE_NAME = exports.DSS_SEARCH_MERCURY_EVENT = exports.DSS_RESULT = exports.DSS_REGISTERED = exports.DSS_LOOKUP_RESULT = exports.DSS_LOOKUP_MERCURY_EVENT = void 0;
var DSS_REGISTERED = exports.DSS_REGISTERED = 'dss:registered';
var DSS_UNREGISTERED = exports.DSS_UNREGISTERED = 'dss:unregistered';
var DSS_LOOKUP_MERCURY_EVENT = exports.DSS_LOOKUP_MERCURY_EVENT = 'event:directory.lookup';
var DSS_SEARCH_MERCURY_EVENT = exports.DSS_SEARCH_MERCURY_EVENT = 'event:directory.search';
var DSS_LOOKUP_RESULT = exports.DSS_LOOKUP_RESULT = 'dss:lookup.result';
var DSS_RESULT = exports.DSS_RESULT = 'dss:result';
var DSS_SERVICE_NAME = exports.DSS_SERVICE_NAME = 'directorySearch';
var SEARCH_TYPES = exports.SEARCH_TYPES = {
  PERSON: 'PERSON',
  CALLING_SERVICE: 'CALLING_SERVICE',
  EXTERNAL_CALLING: 'EXTERNAL_CALLING',
  ROOM: 'ROOM',
  ROBOT: 'ROBOT'
};
var LOOKUP_DATA_PATH = exports.LOOKUP_DATA_PATH = 'lookupResult.entities';
var LOOKUP_FOUND_PATH = exports.LOOKUP_FOUND_PATH = 'lookupResult.entitiesFound';
var LOOKUP_NOT_FOUND_PATH = exports.LOOKUP_NOT_FOUND_PATH = 'lookupResult.entitiesNotFound';
var LOOKUP_REQUEST_KEY = exports.LOOKUP_REQUEST_KEY = 'lookupValues';
var SEARCH_DATA_PATH = exports.SEARCH_DATA_PATH = 'directoryEntities';
//# sourceMappingURL=constants.js.map
